<template>
  <div class="validation-summary-errors" v-if="errors.length > 0">
    <ul>
      <li v-for="err in errors">{{err}}</li>
    </ul>
  </div>
</template>

<script>
  import { defineComponent } from "vue";
  export default defineComponent({
    props: {
      errors: {
        type: Array,
        required: true
      }
    },
  });
</script>
